import React, { useState, useEffect, useRef } from 'react';
import { Modal, Form, App, InputNumber, Input, DatePicker } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { useFeiyongUpdateQuery, useFeiyongUpdateSaveMutation } from '../../store/NeiZhangFeiYongApi';
import ExpenseTypeSelect from '../type/ExpenseTypeSelect';
import UploadOne from '../../cpn/UploadOne';

const { TextArea } = Input;

function ExpenseEdit(props) {   
    const { message } = App.useApp();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const [defaultFileList, setDefaultFileList] = useState([]);
    const [info, setInfo] = useState({
        fy_content: '',
        fy_image: '',
        fy_date: dayjs().format('YYYY-MM-DD'),
        fy_month: dayjs().format('YYYY-MM'),
        fy_year: dayjs().format('YYYY'),
    }); 

    const { data, isSuccess } = useFeiyongUpdateQuery({ fy_id: props.fy_id }, { skip: !open });
    const editForm = useRef();
    const [goodsEdit] = useFeiyongUpdateSaveMutation();

    useEffect(() => {
        if (isSuccess && data?.Status === 'success') {
            let demoImages = [];
            if (data.Result.fy_image) {
                // Handle both array and string formats
                const imageArray = Array.isArray(data.Result.fy_image) 
                    ? data.Result.fy_image 
                    : data.Result.fy_image.split(',').filter(Boolean);
                
                demoImages = imageArray.map((item, index) => ({
                    uid: `${index}-${item}`,
                    url: `/api/assets/images/application/${item}`,
                    thumbUrl: `/api/assets/images/application/${item}`,
                    status: "done",
                    name: item,
                    serverPath: item
                }));
            }

            setDefaultFileList(demoImages);
            
            editForm.current.setFieldsValue({
                fy_content: data.Result.fy_content,
                fy_amount: data.Result.fy_amount,
                fy_shouzhi_id: data.Result.fy_shouzhi_id,
                fy_fyt_id: data.Result.fy_fyt_id,
                fy_date: dayjs(data.Result.fy_date),
            });

            setInfo(prevState => ({
                ...prevState,
                fy_content: data.Result.fy_content,
                fy_amount: data.Result.fy_amount,
                fy_shouzhi_id: data.Result.fy_shouzhi_id,
                fy_date: data.Result.fy_date,
                fy_month: data.Result.fy_month,
                fy_year: data.Result.fy_year,
                fy_fyt_id: data.Result.fy_fyt_id,
                fy_fyt_name: data.Result.fy_fyt_name,
                fy_image: data.Result.fy_image
            }));
        }
    }, [data, isSuccess]);

    const onCreateEdit = (values) => {
        setOpen(false);
    };

    return (
        <>
            <a onClick={() => { setOpen(true) }}><EditOutlined /> 修改</a>
            <Modal
                width={1000}
                open={open}
                title='修改已收已付'
                okText="保存"
                cancelText="取消"
                onCancel={() => { setOpen(false); }}
                onOk={() => {
                    form.validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateEdit(values);
                        })
                        .catch((info) => {
                            console.log('Validate Failed:', info);
                        });

                    goodsEdit({
                        "fy_amount": info.fy_amount,
                        "fy_content": info.fy_content,
                        "fy_date": info.fy_date,
                        "fy_month": info.fy_month,
                        "fy_year": info.fy_year,
                        "fy_fyt_id": info.fy_fyt_id,
                        "fy_fyt_name": info.fy_fyt_name,
                        "fy_image": info.fy_image,
                        "fy_qy_id": props.e_id,
                        "fy_uid": props.eu_id,
                        "fy_uname": props.eu_name,
                        "fy_id": props.fy_id,
                    }).then((res) => {
                        if (res.data.Status === 'success') {
                            message.success('修改成功！');
                            setOpen(false);
                        }
                        if (res.data.Status === 'fail') {
                            message.error('修改失败！' + res.data.Message);
                        }
                    });
                }}
            >
                <Form
                    form={form}
                    layout="horizontal"
                    name="form_client_edit"
                    initialValues={{ modifier: 'public' }}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                >
                    <ExpenseTypeSelect
                        label='类型'
                        name='fy_fyt_id'
                        onChange={(e, f) => {
                            setInfo(prevState => ({
                                ...prevState,
                                fy_fyt_id: e,
                                fy_fyt_name: f
                            }));
                        }}
                        eu_id={props.eu_id}
                        eu_name={props.eu_name}
                        e_id={props.e_id}
                        placeholder='请选择费用类型'
                        wrapperCol={{ span: 5 }}
                    />

                    <Form.Item required name="fy_date" label='日期'>
                        <DatePicker
                            onChange={(e) => {
                                setInfo(prev => ({
                                    ...prev,
                                    fy_date: dayjs(e).format('YYYY-MM-DD'),
                                    fy_month: dayjs(e).format('YYYY-MM'),
                                    fy_year: dayjs(e).format('YYYY'),
                                }));
                            }}
                        />
                    </Form.Item>

                    <Form.Item required name="fy_amount" label='金额'>
                        <InputNumber
                            prefix={<>￥</>}
                            onChange={(e) => {
                                const roundedValue = e !== null ? parseFloat(e.toFixed(2)) : null;
                                setInfo(prevState => ({
                                    ...prevState,
                                    fy_amount: roundedValue
                                }));
                            }}
                            min={0.01}
                            max={99999999.99}
                            precision={2}
                        />
                    </Form.Item>

                    <Form.Item name='fy_content' label='备注' wrapperCol={{ span: 10 }}>
                        <TextArea
                            onChange={(e) => {
                                setInfo(prevState => ({
                                    ...prevState,
                                    fy_content: e.target.value
                                }));
                            }}
                            rows={2}
                        />
                    </Form.Item>

                    <UploadOne
                        fileStr={(e) => {
                            setInfo(prevState => ({
                                ...prevState,
                                fy_image: e
                            }));
                        }}
                        name='fy_image'
                        label='图片'
                        defaultFileList={defaultFileList}
                        maxCount={5}
                    />
                </Form>
            </Modal>
        </>
    );
}

export default ExpenseEdit;